<template>
  <div class="w-100" v-if="modules">
    <div class="d-flex gap-4 justify-content-between align-items-center py-2 border-bottom"
      v-bind:key="_module.module_order" v-for="_module in modules">
      <div class="d-flex gap-4 justify-content-center align-items-center">
        <div class="moduleImageContainer">
          <b-img :src="_module.icon" :alt="_module.alt" rounded ></b-img>
        </div>
        <span>{{ _module.module_name }}</span>
      </div>
      <input :id="_module.id" type="checkbox" :checked="_module.unlocked" :value="_module.module_order"
        v-model="modulesSelected" :disabled="isModuleDisabled(_module.module_order)" />
      <label :for="_module.id" class="material-icons-round m-0"></label>
    </div>
    <b-modal 
      v-model="warningModal" 
      content-class="p-2 atm-rounded" 
      size="md" 
      title="Important!" 
      hide-header-close 
      :hide-footer="true"
      centered>
      <div class="px-3">
        <div class="mb-4">
          To active the Self-Management module, you must have no pending coins to approve.
        </div>
      </div>
      <button class="atm-button flex-grow-1 bg-main font-weight-bold w-100" @click="showHidenModal">
        I GET IT
      </button>
    </b-modal>
  </div>
</template>
<script>
export default {
  data() {
    return {
      modulesSelected: [],
      modulesSelectedCopy: [],
      isSelfManagementSelected: false,
      warningModal: false,
    };
  },
  props: {
    register: {
      type: Boolean,
      default: false,
    },
    modules: {
      type: Array,
      default: () => [],
      required: true,
    },
    coinsPending: {
      type: Boolean,
      default: false,
    },
  },
  mounted() {
    this.modulesSelected = this.modules
      .filter((_module) => _module['unlocked'])
      .map((_module) => _module.module_order);
  },
  methods: {
    selfManagmentIsSelected(selected, oldVal) {
      this.isSelfManagementSelected = selected;
      if (selected) {
        this.modulesSelectedCopy = oldVal;
        this.modulesSelected = [5];
      } else {
        this.modulesSelected = this.modulesSelectedCopy;
      }
    },
    isModuleDisabled(order) {
      if (order === 5) {
        return false;
      } else {
        return this.isSelfManagementSelected;
      }
    },
    clean() {
      this.modulesSelected = [];
    },
    showHidenModal() {
      this.warningModal = !this.warningModal;
    }
  },
  watch: {
    modulesSelected(newVal, oldVal) {
      if (this.coinsPending && newVal.includes(5)) {
        this.$nextTick(() => {
          this.modulesSelectedCopy = oldVal;
          this.modulesSelected = this.modulesSelectedCopy;
          this.showHidenModal();
        });
      } else if (oldVal.length !== 5) {
        this.$emit('onModuleSelectionChange', newVal);
        if (newVal.includes(5) != oldVal.includes(5)) {
          this.selfManagmentIsSelected(newVal.includes(5), oldVal);
        }
      }
    },
  },
};
</script>

<style lang="scss">
.moduleImageContainer {
  width: 50px;
  height: 50px;

  &>img {
    width: 100%;
    height: 100%;
    object-fit: contain;
  }
}
</style>

